module.exports = __webpack_public_path__ + "static/media/hic-logo.8b4f1431.png";